import { useContext, useState, useEffect } from 'react';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { AgentOfferListingsQuery } from 'interfaceAdapter/queries/AgentOfferListings';
import { IPublicCompany } from 'domain/entities/Company/Company';
import { IPublicBuyer } from 'domain/entities/Buyer/Buyer';
import { useLoading } from 'application/contexts/useLoading';

export const useOfferList = () => {
    const diContainer = useContext(diContainerContext);
    const agentOfferListingsQuery = diContainer.resolve(AgentOfferListingsQuery);
    const { loading, setLoading } = useLoading();
    const [offerCompanies, setOfferCompanies] = useState<IPublicCompany[]>([]);
    const [offerBuyers, setOfferBuyers] = useState<IPublicBuyer[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const resOffers = await agentOfferListingsQuery.fetchOffers({});
                setOfferCompanies(resOffers.companies);
                setOfferBuyers(resOffers.buyers);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    return {
        loading,
        offerCompanies,
        offerBuyers,
    };
};
